export async function checkForVoiceActivity(blob: Blob): Promise<boolean> {
  /*
  Check for voice activity
  Args:
   blob (blob): Raw data to be tested for voice activity
  Returns:
   boolean: Indicates if audio blob has voice activity
  */
  // Check fo non empty blob
  if (!blob || blob.size === 0) return false
  // Initiate blob array
  const arrayBuffer = await blob.arrayBuffer()
  //Convert blob array to dataview
  const dataView = new DataView(arrayBuffer)
  //Compute byte length
  const byteLength = dataView.byteLength - (dataView.byteLength % 2)
  if (byteLength === 0) return false

  let sumSquares = 0
  let sampleCount = 0

  for (let i = 0; i < byteLength; i += 2) {
    const sample = dataView.getInt16(i, true)
    sumSquares += sample * sample
    sampleCount++
  }

  const rms = Math.sqrt(sumSquares / sampleCount)
  const rmsThreshold = 1000 // ✅ adjust this threshold as needed
  // Check for vice activity
  return rms > rmsThreshold
}
